// import Swiper JS
import Swiper, { Navigation } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

const HomeHeader = {
    init() {
        // configure Swiper to use modules
        Swiper.use([Navigation]);

        const swiperContainer = document.querySelector('.home-header__slider .swiper-container');
        if (swiperContainer) {
            // init Swiper:
            new Swiper(swiperContainer, {
                slidesPerView: 1,
                spaceBetween: 0,
                allowTouchMove: true,
                updateOnWindowResize: true,
                observer: true,
                observeParents: true,
                loop: true,
                navigation: {
                    nextEl: '.home-header__slider .swiper-button-next',
                    prevEl: '.home-header__slider .swiper-button-prev',
                },
                on: {
                    init() {
                        swiperContainer.classList.add('ready');
                    },
                },
            });
        }
    },
};

export default HomeHeader;
